import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)

export default new Vuex.Store({
   state: {
      status: '',
      token: localStorage.getItem('token') || '',
      user : {}
   },
   mutations: {
      auth_success(state, data) {
         state.status = 'success'
         state.token = data.token
         localStorage.setItem('token', data.token)
         state.user = { 'fullname': data.nombre, 'email': data.email, 'zones': data.zonas, 'selectedZone': data.zonas[0] }
      },
      auth_fail(state) {
         state.status = ''
         state.token = ''
         localStorage.clear()
         localStorage.removeItem('vuex')
         state.user = {}
      },
      change_zone(state, index) {
         state.user.selectedZone = state.user.zones[index]
      }
   },
   actions: {
      login({commit}, params) {
         return new Promise((resolve, reject) => {
            axios({url: 'https://portal.asein.es/api-v2/auth', data: params, method: 'POST' })
            .then(resp => {
               if (resp.data.res == "success") {
                  commit('auth_success', resp.data)
               } else {
                  commit('auth_fail')
               }
               resolve(resp)       
            })
            .catch(err => {
               localStorage.removeItem('token')
               console.log(err)
               reject(err)
            })
         })
      },
      logout({commit}) {
         commit('auth_fail')
      }
   },
   getters : {
      isLoggedIn: state => !!state.token,
      authStatus: state => state.status,
   },
   plugins: [createPersistedState()]
})
